import LazyLoad from "vanilla-lazyload";
import { registerDropdowns } from "../components/dropdown";
import { registerThemeHandler } from "../components/themes";
import { onReady } from "../utils/page-lifecycle";

onReady(() => {
  const lazyLoadInstance = new LazyLoad({});
  registerDropdowns();
  registerThemeHandler();
  // registerLoader();
});
